import update from 'immutability-helper'
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'
import { cloneDeep } from 'lodash'

extendUpdate(update)

const exportData = {
	[ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY]: (state) =>
		update(state, {
			table: {
				isLoading: { $set: true },
			},
		}),
	[ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS]: (state, payload) => {
		const userTableReferential = cloneDeep(state.user.tableReferential)

		const arr_label = payload.data.label.split('_')
		const labelTableReferential = arr_label[0]

		let savedColumnsDisplay

		userTableReferential.forEach((tableReferential) => {
			if (tableReferential.label === labelTableReferential) {
				tableReferential.columnPreference.forEach((columnReferential) => {
					if (columnReferential.label === payload.data.label) {
						columnReferential.select = payload.data.select
					}
				})
				savedColumnsDisplay = {
					idPageTable: tableReferential.id,
					label: tableReferential.label,
					columnPreference: tableReferential.columnPreference,
				}
			}
		})

		return update(state, {
			table: {
				isLoading: { $set: false },
				savedColumnsDisplay: {
					$set: savedColumnsDisplay,
				},
			},
			user: {
				tableReferential: {
					$set: userTableReferential,
				},
			},
		})
	},
	[ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE]: (state, payload) =>
		update(state, {
			table: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY]: (state) =>
		update(state, {
			user: {
				tableReferential: {
					$set: [],
				},
			},
			isLoading: { $set: true },
		}),
	[ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS]: (state, payload) => {
		return update(state, {
			user: {
				tableReferential: {
					$set: payload.data,
				},
			},
			isLoading: { $set: true },
		})
	},
	[ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE]: (state, payload) =>
		update(state, {
			user: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_SAVED_PAGGING_CONFIG]: (state, payload) =>
		update(state, {
			user: {
				paggingConfig: {
					$set: payload,
				},
			},
		}),
	[ActionsTypes.RESET_PAGGING_CONFIG]: (state) =>
		update(state, {
			user: {
				paggingConfig: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.SET_IS_FROM_REDIRECT]: (state) =>
		update(state, {
			table: {
				isFromRedirect: {
					$set: true,
				},
			},
		}),
}

export default exportData
